import React, { useState } from 'react';
import styles from './styles.scss';
import moment from 'moment';
import Calendar from 'react-calendar';
import { WIDGET_LOCALE } from '../../../../../../../locale-wrapper';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ColorDescription } from '../../ColorDescription';
import { List } from 'immutable';

export const CalendarView = ({ event, occurrences = List(), setOccurrencesDate, settings }) => {
  const [selectedDate, setSelectedDate] = useState(new Date());

  const dates = occurrences.toArray().reduce((accum, occurrenceDate) => {
    const timeEntries = occurrenceDate.get('time_entries') || List();
    const tickets = timeEntries.map((record) => record.get('tickets')) || [];
    const status = event.get('event_setup') === 'tickets' ? tickets.toArray().some((ticket) => ticket.first().get('status') === 'onsale') : true;

    return Object.assign(accum, { [moment(occurrenceDate.get('start_date')).format('yyyy-MM-D')]: status });
  }, {});

  const handleOnClick = (value) => {
    setOccurrencesDate(moment(value));
    setSelectedDate(value);
  };

  const currentDate = new Date();
  const tileDisabled = ({ date }) => date < new Date(currentDate.setHours(0, 0, 0, 0));

  return (
    <div className={styles.wrapper}>
      <Calendar
        locale={WIDGET_LOCALE}
        showNeighboringMonth={false}
        prevLabel={<ChevronLeftIcon />}
        nextLabel={<ChevronRightIcon />}
        minDetail="month"
        value={selectedDate}
        tileDisabled={tileDisabled}
        onChange={handleOnClick}
        tileClassName={({ date }) => {
          const dateKey = moment(date).format('yyyy-MM-D');
          if (Object.keys(dates).includes(dateKey)) {
            return dates[dateKey] ? styles.onSaleCell : styles.soldOutCell;
          }
          return null;
        }}
      />
      <ColorDescription settings={settings} />
    </div>
  );
};
